import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { shallowEqual, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { get } from 'lodash';
import { RootState } from 'modules';
import MenteeCard from 'components/mentoring/mentee/MenteeCard';
import { MentoringClassWrapper } from 'components/mentoring/styles';
import { getMentees } from 'libs/api/user';
import { useDataApi } from 'libs/hooks';
import { TListResponse } from 'modules/types';
import { TMentee } from 'modules/user';
import { CWindowWidth } from 'constants/base.const';
import { CMentoringFieldType } from 'constants/mentoring.const';
import { List, Col, Row, Typography, Spin } from 'antd';
import { device } from 'GlobalStyles';

const { Text, Title } = Typography;
const MentoringMyMentee = () => {
  const [key, setKey] = useState('mentee');
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const [{ data, loading }] = useDataApi<TListResponse<TMentee>>(
    getMentees.bind(null, {
      params: {
        current: 1,
        pageSize: 99,
        mentoringField: currentUser?.primary_field,
      },
    }),
  );
  const isMobile = useMediaQuery({ query: device.md });
  const defaultPadding = isMobile === true ? 1 : 16;

  return (
    <MentoringClassWrapper>
      <Helmet>
        <title>
          {currentUser?.primary_field && CMentoringFieldType[currentUser?.primary_field]} - 나의 멘티 보기
        </title>
      </Helmet>
      <Spin tip='loading...' spinning={false}>
        <Row
          style={{
            maxWidth: `${CWindowWidth - 300}px`,
            margin: '20px auto',
            padding: `30px ${defaultPadding}px`,
          }}
          gutter={[2 * defaultPadding, defaultPadding]}
        >
          <Col
            xs={{ span: 24, order: 2 }}
            sm={{ span: 24, order: 2 }}
            md={{ span: 16, order: 1 }}
            lg={{ span: 16, order: 1 }}
            xl={{ span: 17, order: 1 }}
          >
            <Title level={2} style={{ marginBottom: '15px' }}>
              나의 멘티
            </Title>
            <List
              loading={loading}
              style={{ paddingTop: '20px' }}
              grid={{
                gutter: defaultPadding,
                xs: 2,
                sm: 2,
                md: 2,
                lg: 2,
                xl: 3,
                xxl: 3,
              }}
              dataSource={get(data, 'contents')}
              renderItem={(item) => (
                <List.Item>
                  <MenteeCard
                    mentee={item}
                    style={{ margin: '0px auto', maxWidth: '280px' }}
                    useInterested={false}
                    useResume={false}
                    useClassCount={true}
                  />
                </List.Item>
              )}
            />
          </Col>
          <Col
            xs={{ span: 24, order: 1 }}
            sm={{ span: 24, order: 1 }}
            md={{ span: 7, offset: 1 }}
            lg={{ span: 7, offset: 1 }}
            xl={{ span: 6, offset: 1 }}
            style={{ textAlign: 'center' }}
          >
            <div className='border-box hide-on-mobile' style={{ textAlign: 'left' }}>
              <Title level={4}>
                내가 수업을 했던
                <br />
                멘티들이 노출됩니다.
              </Title>
              <Text style={{ fontSize: '13px' }}>나와 한번이라도 수업했던 멘티들이 노출됩니다.</Text>
            </div>
          </Col>
        </Row>
      </Spin>
    </MentoringClassWrapper>
  );
};

export default MentoringMyMentee;
